import {
  Box,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  IconButton,
  Typography,
  Avatar,
  Tooltip,
  CardMedia,
  Badge,
} from "@mui/material"
import {
  Favorite,
  Share,
  Visibility as VisibilityIcon,
  Message as MessageIcon,
  Shop as ShopIcon,
  Edit as EditIcon,
} from "@mui/icons-material"
import PreviewIcon from "@mui/icons-material/Preview"
import { useEffect, useRef, useState } from "react"
import ViewSkillModal from "../Modals/ViewSkillModal/ViewSkillModal"
import ChatModal from "../Modals/ChatModal/ChatModal"
import NewSkillModal from "../Modals/NewSkillModal/NewSkillModal"
import { useApiService } from "../hooks/Api/useApiService"
import { useNavigate } from "react-router-dom"
import styles from "./FeedItem.module.css"
import { useUser } from "../hooks/Contexts/UserContext/UserContext"
import StarBorderIcon from "@mui/icons-material/StarBorder"
import RatingModal from "../Modals/RatingModal/RatingModal"
import UsersPopup from "../UI/UserPopup/UsersPopup"
import DeleteForeverIcon from "@mui/icons-material/DeleteForever"
import Popup from "../Popup/Popup"
import Icn from "../UI/SharieIcn/SharieIcn"
import FullscreenIcon from "@mui/icons-material/Fullscreen"
import CloseIcon from "@mui/icons-material/Close"
import { Dialog } from "@mui/material"
import T from "../hooks/Language/T"
import React from "react"
import Spinner from "../UI/Spinner/Spinner"
import useDeviceType from "../hooks/Utils/useDeviceType"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import useTranslationSharie from "../hooks/Language/useTranslation"
import confetti from "canvas-confetti"
import LibraryAddIcon from "@mui/icons-material/LibraryAdd"
import i18n from "i18next"
import NewDemandModal from "../Modals/NewDemandModal/NewDemandModal"
import useError from "../hooks/Error/useError"
import { useSocket } from "../hooks/Utils/Socket/SocketManager"

const FeedItem = (props) => {
  const [open_edit, setOpenEdit] = useState(false)
  const [fullscreenImg, setFullscreenImg] = useState(false)
  const [likes, setLikes] = useState(null)
  const [deleting, setDeleting] = useState(false)
  const { postData, domain } = useApiService()
  const viewRef = useRef()
  const chatRef = useRef()
  const skillRef = useRef()
  const ratingRef = useRef()
  const demandRef = useRef()
  const is_user = props.skill.user_name === localStorage.getItem("user")
  const navigate = useNavigate()
  const { context_user } = useUser()
  const [skill_user_image, setSkillUserImage] = useState(null)
  const [level_color, setLevelColor] = useState("white")
  const videoRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)
  const [buying, setBuying] = useState(false)
  const deviceType = useDeviceType()
  const isDesktop = deviceType === "desktop"
  const t = useTranslationSharie()
  const [should_fetch, setShouldFetch] = useState(false)
  const isHebrew = i18n.language === "he"
  const post =
    props.skill?.wisdom === undefined &&
    props.skill?.duration !== "demand" &&
    props.skill?.image !== null

  const { Error: ErrorAlert, error, success } = useError()
  const socket = useSocket()
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await postData("users/getusersimages", { users: [props.skill.user_name] })
        setSkillUserImage(data.images[0])
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }

    fetchData()
  }, [props.skill.user_name])
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true)
        } else {
          setIsVisible(false)
        }
      },
      { threshold: 0.5 }
    )
    if (videoRef.current) {
      observer.observe(videoRef.current)
    }
    return () => {
      if (videoRef.current) {
        observer.unobserve(videoRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (isVisible && videoRef.current) {
      videoRef.current.play()
    } else if (videoRef.current) {
      videoRef.current.pause()
    }
  }, [isVisible])

  useEffect(() => {
    const fetchLikesAndUser = async () => {
      try {
        const likeData = await postData("sharie/getlikesbyskill", {
          skill_data: props.skill,
          to: props.skill.user_name,
        })
        setLikes(likeData.likes)
        const userData = await postData("users/getuser", { user_name: props.skill.user_name })
        setSkillUserImage(userData.user[0].image)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    }
    fetchLikesAndUser()
    checkLevelColor()
  }, [should_fetch, props.skill])
  const checkLevelColor = () => {
    if (props.skill.level === "beginner") {
      setLevelColor("#4CAF50") // Green
    } else if (props.skill.level === "advanced") {
      setLevelColor("#FF9800") // Orange
    } else if (props.skill.level === "expert") {
      setLevelColor("#F44336") // Red
    } else {
      setLevelColor("white")
    }
  }
  const openModal = (modalRef) => modalRef.current?.childFunction()

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: props.skill.name + " - " + props.skill.user_name || "Default Title",
          text: props.skill.description || "Default text to share",
          url: domain + "/shareskill/" + props.skill._id,
        })
        sendNotification("share skill")
      } catch (error) {
        error(error.message)
      }
    } else {
      error("Sharing is not supported")
    }
  }
  const handleConfetti = () => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
    })
  }
  const sendTransaction = async () => {
    try {
      const data = await postData("transactions/addtransaction", {
        skill_data: props.skill,
        from: localStorage.getItem("user"),
        is_group: props.skill.max_participants ? true : false,
      })
      if (data?.transactions === null || data?.message !== "Successful") {
        error(data?.message)
      } else {
        handleConfetti()
        success("Transaction Sent Successfully!")
        sendNotification("buy skill")
      }
    } catch (error) {
      error(error.message)
    }
    setBuying(false)
  }

  const sendLike = async () => {
    const user = localStorage.getItem("user")
    if (props.skill.user_name !== user) {
      try {
        const data = await postData("sharie/addlike", {
          skill_data: props.skill,
          from: user,
        })

        setLikes(data.likes)
        sendNotification("like")
        setShouldFetch(!should_fetch)
      } catch (error) {
        console.error("Error sending like:", error)
      }
    }
  }
  const sendNotification = (type) => {
    try {
      socket?.emit("send_notification", {
        toUserId: props.skill.user_id,
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        to: props.skill.user_name,
        type: type,
      })
      postData("sharie/addnotification", {
        skill_name: props.skill.name,
        from: localStorage.getItem("user"),
        to: props.skill.user_name,
        type: type,
      }).then((data) => {})
    } catch (error) {
      console.error("Error sending notification:", error)
    }
  }
  const handleAvatarClick = () => {
    sendNotification("view profile")
    navigate("/profile", {
      state: {
        user_name: props.skill.user_name,
        editable: context_user?.user_name === props.skill.user_name,
      },
    })
  }
  const openViewModal = async () => {
    sendNotification("view " + (props.skill.max_participants ? "group" : "skill"))

    openModal(viewRef)
  }

  const checkBase64FileType = (base64String) => {
    // Regular expressions to match image and video MIME types
    const imageRegex = /^data:image\/(jpeg|png|gif|bmp|webp|svg\+xml);base64,/
    const videoRegex = /^data:video\/(mp4|webm|ogg);base64,/

    // Check if it's an image
    if (imageRegex.test(base64String)) {
      return "image"
    }

    // Check if it's a video
    if (videoRegex.test(base64String)) {
      return "video"
    }

    // If neither, return 'unknown'
    return "unknown"
  }
  const handleConfirm = () => {
    setDeleting(false)
    postData("skills/deleteskill", {
      name: props.skill.name,
      user_name: localStorage.getItem("user"),
    }).then((data) => {
      if (data.message === "Successful") {
        success("Deleted Successfuly")
        props.setFinishedDeleting(!props.finished_deleting)
        props.setShouldFetch(!props.should_fetch)
      } else {
        error(data.message)
      }
    })
  }
  const handleViewGroup = () => {
    navigate("/groups", {
      state: {
        skill: props.skill,
      },
    })
  }
  const handleOpenEdit = () => {
    setTimeout(() => {
      setOpenEdit(false)
    }, 3500)
    setOpenEdit(!open_edit)
  }
  const handleSavePost = () => {
    postData("skills/saveskill", {
      name: props.skill.name,
      user_name: localStorage.getItem("user") || context_user?.user,
      skill_user_name: props.skill.user_name,
    }).then((data) => {
      if (data.message === "Successful") {
        success("Saved Successfully")
      } else {
        error(data.message)
      }
    })
  }

  return (
    <T>
      <NewSkillModal
        ref={skillRef}
        skill={props.skill}
        mode={"update"}
        setShouldFetch={props.setShouldFetch}
      />
      <NewDemandModal
        ref={demandRef}
        skill={props.skill}
        mode={"update"}
        setShouldFetch={props.setShouldFetch}
      />
      <ViewSkillModal ref={viewRef} skill={props.skill} />
      <ChatModal
        ref={chatRef}
        chat_user={localStorage.getItem("user")}
        to={props.skill.user_name}
        skill={props.skill}
      />
      <RatingModal ref={ratingRef} skill={props.skill} />
      <React.Suspense fallback={<Spinner />}>
        <Tooltip
          placement='left'
          arrow
          enterDelay={300}
          title={props.skill.max_participants ? t("Group") : post ? t("Skill") : t("Demand")}
        >
          <Card
            className={styles.feeditem_card_container}
            sx={{ borderRadius: "0.8rem", borderTop: "3px solid " + level_color }}
          >
            {deleting && (
              <Popup
                open={deleting}
                handleClose={() => setDeleting(false)}
                handleConfirm={handleConfirm}
              />
            )}
            <div className={styles.feeditem_inner_container}>
              <CardHeader
                avatar={
                  <Icn
                    tooltip='View Profile'
                    onClick={handleAvatarClick}
                    avatar={
                      <Avatar
                        src={skill_user_image || props.image}
                        alt={props.skill.user_name}
                        sx={{
                          border: `3px solid ${
                            props.is_group ? "#9c27b0" : post ? "#1976d2" : "#ff9800"
                          }`,
                        }}
                      />
                    }
                  />
                }
                title={
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {props.skill.user_name !== localStorage.getItem("user") && (
                      <Icn
                        tooltip='Chat'
                        color='lightGreen'
                        onClick={() => openModal(chatRef)}
                        label='message'
                        icon={<MessageIcon />}
                      />
                    )}
                    <Typography sx={{ color: "text.primary" }}>
                      {props.skill?.name || props.skill?.wisdom?.question}
                    </Typography>
                  </div>
                }
                // subheader={
                //   <Typography sx={{ textAlign: "left", color: "text.secondary" }}>
                //     {props.skill.user_name}
                //   </Typography>
                // }
              />

              <div
                className={
                  isDesktop ? styles.edit_view_container_desktop : styles.edit_view_container_mobile
                }
              >
                {is_user && (
                  <>
                    {open_edit && (
                      <>
                        <Icn
                          tooltip='Edit Post'
                          color='green'
                          onClick={() =>
                            props.skill?.duration === "demand"
                              ? openModal(demandRef)
                              : openModal(skillRef)
                          }
                          icon={<EditIcon />}
                        />
                        <Icn
                          tooltip='Delete'
                          color='red'
                          onClick={() => setDeleting(true)}
                          icon={<DeleteForeverIcon />}
                        />
                      </>
                    )}
                    {!props.skill.wisdom && (
                      <Icn
                        tooltip={open_edit ? "Close Edit" : "Open Edit"}
                        color='gray'
                        onClick={handleOpenEdit}
                        icon={open_edit ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                      />
                    )}
                  </>
                )}
                {post && !props.skill.wisdom && (
                  <Icn
                    tooltip={"Save Post"}
                    onClick={handleSavePost}
                    icon={<LibraryAddIcon style={{ color: "#FFEB99" }} />}
                  />
                )}
                {!post && (
                  <Icn
                    tooltip={"View " + (props.skill.max_participants ? "Group" : "Skill")}
                    onClick={openViewModal}
                    icon={<VisibilityIcon style={{ color: "#80CBC4" }} />}
                  />
                )}
              </div>
            </div>
            <Typography
              variant='body1'
              color='text.secondary'
              sx={{
                marginInlineStart: "1rem",

                marginInlineEnd: "1rem",
                textAlign: isHebrew ? "right" : "left",
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {props.skill.description || props.skill.wisdom?.quote}
            </Typography>
            {post && (
              <CardContent>
                {checkBase64FileType(props.skill?.image) === "video" ? (
                  <Box sx={{ position: "relative", width: "100%" }}>
                    <CardMedia
                      component='video'
                      controls
                      ref={videoRef}
                      muted
                      loop
                      playsInline
                      sx={{
                        height: 500,
                        borderRadius: 2,
                        objectFit: "cover",
                      }}
                    >
                      <source src={props.skill?.image} type='video/mp4' />
                      Your browser does not support the video tag.
                    </CardMedia>

                    <Box
                      sx={{
                        position: "absolute",
                        top: 10,
                        left: 10,
                        background: "rgba(0,0,0,0.5)",
                        borderRadius: "50%",
                      }}
                    >
                      <Icn
                        tooltip={"View " + (props.skill.max_participants ? "Group" : "Skill")}
                        onClick={openViewModal}
                        icon={<VisibilityIcon style={{ color: "#80CBC4" }} />}
                      />
                    </Box>
                  </Box>
                ) : (
                  props.skill.image && (
                    <Box position='relative'>
                      <CardMedia
                        hover
                        component='img'
                        height='500'
                        image={props.skill.image}
                        alt='Skill image'
                        sx={{
                          transition: "transform 0.3s ease",
                          "&:hover": {
                            transform: "scale(1.2)",
                            cursor: "pointer",
                          },
                        }}
                      />
                      <IconButton
                        sx={{
                          position: "absolute",
                          top: 10,
                          right: 10,
                          color: "text.primary",
                          background: "rgba(0,0,0,0.5)",
                        }}
                        onClick={() => setFullscreenImg(true)}
                      >
                        <FullscreenIcon />
                      </IconButton>
                      <div
                        style={{
                          position: "absolute",
                          top: 10,
                          left: 10,
                          color: "text.primary",
                          background: "rgba(0,0,0,0.5)",
                          borderRadius: "50%",
                        }}
                      >
                        <Icn
                          tooltip={"View " + (props.skill.max_participants ? "Group" : "Skill")}
                          onClick={openViewModal}
                          icon={<VisibilityIcon style={{ color: "#80CBC4" }} />}
                        />
                      </div>
                    </Box>
                  )
                )}
              </CardContent>
            )}

            {props.skill.wisdom && (
              <Typography
                variant='body1'
                color='text.primary'
                sx={{
                  marginInlineStart: "1rem",
                  marginInlineEnd: "1rem",
                  textAlign: isHebrew ? "right" : "left",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {props.skill.reflection}
              </Typography>
            )}
            {!post && (
              <Tooltip arrow title={t("Like")}>
                <Badge
                  badgeContent={likes?.length}
                  overlap='circular'
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  sx={{
                    "& .MuiBadge-badge": {
                      backgroundColor: "background.paper", // Custom background color (green)
                      color: "black", // Text color
                    },
                  }}
                >
                  <Icn
                    tooltip='like'
                    onClick={sendLike}
                    label='like'
                    icon={
                      <Favorite
                        sx={{
                          stroke: "red", // Border color
                          strokeWidth: 1.5, // Border thickness
                          fill: likes?.some((el) => el.from === localStorage.getItem("user"))
                            ? "red"
                            : "white", // Fill color
                          strokeLinejoin: "round",
                        }}
                      />
                    }
                  />
                </Badge>
              </Tooltip>
            )}
            {post && (
              <CardActions disableSpacing>
                <Box className={styles.actions_container}>
                  {/* <Box className={styles.icons_box}> */}
                  <>
                    {/* <Typography variant="body1" color="text.secondary" sx={{ marginRight: 1 }}>
                {likes?.length}
              </Typography> */}
                    <Tooltip arrow title={t("Like")}>
                      <Badge
                        badgeContent={likes?.length}
                        overlap='circular'
                        anchorOrigin={{
                          vertical: "top",
                          horizontal: "left",
                        }}
                        sx={{
                          "& .MuiBadge-badge": {
                            backgroundColor: "background.paper", // Custom background color (green)
                            color: "black", // Text color
                          },
                        }}
                      >
                        <Icn
                          tooltip='like'
                          onClick={sendLike}
                          label='like'
                          icon={
                            <Favorite
                              sx={{
                                stroke: "red", // Border color
                                strokeWidth: 1.5, // Border thickness
                                fill: likes?.some((el) => el.from === localStorage.getItem("user"))
                                  ? "red"
                                  : "white", // Fill color
                                strokeLinejoin: "round",
                              }}
                            />
                          }
                        />
                      </Badge>
                    </Tooltip>
                  </>

                  {props.skill.user_name !== localStorage.getItem("user") && (
                    <>
                      {!props.skill.max_participants ? (
                        <>
                          <Icn
                            tooltip={
                              props.skill.cost > context_user?.credit
                                ? "Not Enough Credit!"
                                : "Buy Skill"
                            }
                            color='#1976d2'
                            onClick={() => setBuying(true)}
                            label='purchase'
                            className={"shop_icon"}
                            icon={<ShopIcon />}
                          />
                          {buying && (
                            <Popup
                              open={buying}
                              handleClose={() => setBuying(false)}
                              handleConfirm={sendTransaction}
                            />
                          )}
                        </>
                      ) : (
                        <Icn
                          tooltip='View Group'
                          color='#1976d2'
                          onClick={handleViewGroup}
                          label='view group'
                          icon={<PreviewIcon />}
                        />
                      )}
                    </>
                  )}

                  {props.skill.user_name === localStorage.getItem("user") &&
                    props.skill.max_participants && (
                      <Icn
                        tooltip='View Group'
                        color='#1976d2'
                        onClick={handleViewGroup}
                        label='view group'
                        icon={<PreviewIcon />}
                      />
                    )}
                  {post && (
                    <>
                      <Icn
                        tooltip={"Share"}
                        color={"purple"}
                        onClick={handleShare}
                        label='share'
                        icon={<Share />}
                      />
                      <Icn
                        tooltip={"Reviews"}
                        color={"orange"}
                        onClick={() => openModal(ratingRef)}
                        label='rating'
                        icon={<StarBorderIcon />}
                      />
                      <UsersPopup skill={props.skill} />
                    </>
                  )}
                  {/* </Box> */}
                </Box>
              </CardActions>
            )}
            {/* <Box
              style={{
                display: "flex",
                flexDirection: "row-reverse",
              }}
            >
              <Rating name='skill-rating' value={props.skill.rating || 0} precision={1} readOnly />
            </Box> */}
            <Dialog
              open={fullscreenImg}
              onClose={() => setFullscreenImg(false)}
              maxWidth='xl'
              fullScreen // This makes the dialog cover the whole screen
              sx={{ backgroundColor: "black" }} // Black background for better view
            >
              <IconButton
                sx={{
                  position: "absolute",
                  top: 10,
                  right: 10,
                  color: "text.primary",
                  background: "rgba(0,0,0,0.5)",
                  zIndex: 10,
                }}
                onClick={() => setFullscreenImg(false)}
              >
                <CloseIcon />
              </IconButton>

              <Box
                sx={{
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <img
                  src={props.skill.image}
                  alt='Fullscreen'
                  style={{
                    width: "100vw",
                    height: "100vh",
                    objectFit: "contain", // Ensures it scales correctly without distortion
                  }}
                />
              </Box>
            </Dialog>
          </Card>
        </Tooltip>
      </React.Suspense>
      <ErrorAlert />
    </T>
  )
}

export default React.memo(FeedItem)
